[
  {
    "code": "ES-AN",
    "name": "Andalucía"
  },
  {
    "code": "ES-AR",
    "name": "Aragón"
  },
  {
    "code": "ES-AS",
    "name": "Asturias, Principado de"
  },
  {
    "code": "ES-CN",
    "name": "Canarias"
  },
  {
    "code": "ES-CB",
    "name": "Cantabria"
  },
  {
    "code": "ES-CL",
    "name": "Castilla y León"
  },
  {
    "code": "ES-CM",
    "name": "Castilla-La Mancha"
  },
  {
    "code": "ES-CT",
    "name": "Cataluña"
  },
  {
    "code": "ES-CE",
    "name": "Ceuta"
  },
  {
    "code": "ES-EX",
    "name": "Extremadura"
  },
  {
    "code": "ES-GA",
    "name": "Galicia"
  },
  {
    "code": "ES-IB",
    "name": "Illes Baleares"
  },
  {
    "code": "ES-RI",
    "name": "La Rioja"
  },
  {
    "code": "ES-MD",
    "name": "Madrid, Comunidad de"
  },
  {
    "code": "ES-ML",
    "name": "Melilla"
  },
  {
    "code": "ES-MC",
    "name": "Murcia, Región de"
  },
  {
    "code": "ES-NC",
    "name": "Navarra, Comunidad Foral de"
  },
  {
    "code": "ES-PV",
    "name": "País Vasco"
  },
  {
    "code": "ES-VC",
    "name": "Valenciana, Comunidad"
  }
]